import { Section, SelectorIdentifier } from '../../../models';
import { TritonSectionIds, Mp2FlowFieldId } from '../base-config-models';
import { getParameterValue } from '../utils';
import { field } from '../../../core/field-schema';
import { LocationCardEntity } from 'app/shared/components/location-card/models/location-card.model';
import { TritonLocationCardState } from '../models';

export const mp2Flow = (state: TritonLocationCardState): Section => {
    const details = state.locationDetails && state.locationDetails.length > 0 ? state.locationDetails[1] : null;

    return {
        info: {
            id: TritonSectionIds.Flow2,
            title: 'ADD_EDIT.FLOW_FORM_2',
            displayTitle: true,
            expandable: true,
            expanded: false,
        },

        rows: [
            {
                info: {
                    id: 'flow-parameters-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.select<LocationCardEntity, number>(Mp2FlowFieldId.Parameters, 'flowType', {
                        placeholder: 'ADD_EDIT.PARAMETERS',
                        valueMapper: (option) => option.id,
                        displayMapper: (option) => option.name,
                        panelClass: 'full-width',
                        disabled: true,
                        value: details ? getParameterValue(details.installationShapeTypeID) : null,
                        optionsSelector: SelectorIdentifier.FlowParamsMp2,
                    }),
                ],
            },
        ],
    };
};
